module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/corte-caja/historico-corte-caja/historico-corte-caja.component.scss
// module id = ./src/app/corte-caja/historico-corte-caja/historico-corte-caja.component.scss
// module chunks = main